import { format } from 'date-fns';
import type { TaskStatisticsOutputDto } from '../model';

export async function exportCreditStatistics(
  data: TaskStatisticsOutputDto['account_stats'],
  rangeTime: TaskStatisticsOutputDto['range_time'],
): Promise<void> {
  const { writeXlsx } = await import('hucre/xlsx');
  const bytes = await writeXlsx({
    sheets: [
      {
        name: '信用点统计',
        columns: [
          { header: '账户', key: 'account', width: 28 },
          { header: '每日信用点额度', key: 'credit', width: 20 },
          { header: '信用点使用量', key: 'cost', width: 18 },
        ],
        data: data.map((row) => ({
          account: row.account_name,
          credit: row.credit === -1 ? '无限额度' : row.credit,
          cost: row.cost,
        })),
      },
    ],
  });
  const blob = new Blob([new Uint8Array(bytes)], {
    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  });
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  try {
    link.href = url;
    link.download =
      '信用点统计_' +
      format(rangeTime[0], 'yyyyMMdd') +
      '_' +
      format(rangeTime[1], 'yyyyMMdd') +
      '.xlsx';
    document.body.appendChild(link);
    link.click();
  } finally {
    link.remove();
    // 延迟释放，给浏览器留出开始读取下载内容的时间。
    setTimeout(() => URL.revokeObjectURL(url), 1000);
  }
}
